/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createProduct = /* GraphQL */ `
  mutation CreateProduct($input: CreateProductInput!) {
    createProduct(input: $input) {
      id
      code
      description
      distributor_cost
      dealer_cost
      manufacture_cost
      msrp
      name
      product_type_id
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      id
      code
      description
      distributor_cost
      dealer_cost
      manufacture_cost
      msrp
      name
      product_type_id
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct($input: DeleteProductInput!) {
    deleteProduct(input: $input) {
      id
      code
      description
      distributor_cost
      dealer_cost
      manufacture_cost
      msrp
      name
      product_type_id
    }
  }
`;
export const createService = /* GraphQL */ `
  mutation CreateService($input: CreateServiceInput!) {
    createService(input: $input) {
      code
      description
    }
  }
`;
export const deleteService = /* GraphQL */ `
  mutation DeleteService($input: DeleteServiceInput!) {
    deleteService(input: $input) {
      code
      description
    }
  }
`;
export const updateService = /* GraphQL */ `
  mutation UpdateService($input: UpdateServiceInput!) {
    updateService(input: $input) {
      id
      code
      description
      distributor_cost
      dealer_cost
      manufacture_cost
      msrp
      name
      product_type_id
    }
  }
`;
export const createProductType = /* GraphQL */ `
  mutation CreateProductType($input: CreateProductTypeInput!) {
    createProductType(input: $input) {
      id
      name
    }
  }
`;
export const updateProductType = /* GraphQL */ `
  mutation UpdateProductType($input: UpdateProductTypeInput!) {
    updateProductType(input: $input) {
      id
      name
    }
  }
`;
export const deleteProductType = /* GraphQL */ `
  mutation DeleteProductType($input: DeleteProductTypeInput!) {
    deleteProductType(input: $input) {
      id
      name
    }
  }
`;
export const addProductType = /* GraphQL */ `
  mutation AddProductType($input: AddProductTypeInput!) {
    addProductType(input: $input) {
      id
      code
      description
      distributor_cost
      dealer_cost
      manufacture_cost
      msrp
      name
      product_type_id
    }
  }
`;
export const removeProductType = /* GraphQL */ `
  mutation RemoveProductType($input: RemoveProductTypeInput!) {
    removeProductType(input: $input) {
      id
      code
      description
      distributor_cost
      dealer_cost
      manufacture_cost
      msrp
      name
      product_type_id
    }
  }
`;
export const createPart = /* GraphQL */ `
  mutation CreatePart($input: CreatePartInput!) {
    createPart(input: $input) {
      number
      description
      distributor_cost
      dealer_cost
      manufacture_cost
      msrp
      service_code
      part_number
      product_id
    }
  }
`;
export const updatePart = /* GraphQL */ `
  mutation UpdatePart($input: CreatePartInput!) {
    updatePart(input: $input) {
      number
      description
      distributor_cost
      dealer_cost
      manufacture_cost
      msrp
      service_code
      part_number
      product_id
    }
  }
`;
export const deletePart = /* GraphQL */ `
  mutation DeletePart($input: DeletePartInput!) {
    deletePart(input: $input) {
      number
      description
      distributor_cost
      dealer_cost
      manufacture_cost
      msrp
      service_code
      part_number
      product_id
    }
  }
`;
export const createProductPart = /* GraphQL */ `
  mutation CreateProductPart($input: ProductPartInput!) {
    createProductPart(input: $input) {
      part_number
      product_id
    }
  }
`;
export const deleteProductPart = /* GraphQL */ `
  mutation DeleteProductPart($input: ProductPartInput!) {
    deleteProductPart(input: $input) {
      part_number
      product_id
    }
  }
`;
export const createServiceProductPart = /* GraphQL */ `
  mutation CreateServiceProductPart($input: ServiceProductPartInput!) {
    createServiceProductPart(input: $input) {
      service_code
      part_number
      product_id
    }
  }
`;
export const deleteServiceProductPart = /* GraphQL */ `
  mutation DeleteServiceProductPart($input: ServiceProductPartInput!) {
    deleteServiceProductPart(input: $input) {
      service_code
      part_number
      product_id
    }
  }
`;
export const roleHandler = /* GraphQL */ `
  mutation RoleHandler($input: RoleInput!) {
    roleHandler(input: $input) {
      id
      name
    }
  }
`;
export const roleReader = /* GraphQL */ `
  mutation RoleReader($input: RoleInput!) {
    roleReader(input: $input) {
      id
      name
    }
  }
`;
export const itemHandler = /* GraphQL */ `
  mutation ItemHandler($input: ItemInput!) {
    itemHandler(input: $input) {
      serial
      product_id
      person_id
      date_purchase
      date_production
      image_key
      order_number
      po_number
    }
  }
`;
export const personHandler = /* GraphQL */ `
  mutation PersonHandler($input: PersonInput!) {
    personHandler(input: $input) {
      id
      cognito_id
      first_name
      last_name
      address
      country
      email
    }
  }
`;
export const companyHandler = /* GraphQL */ `
  mutation CompanyHandler($input: CompanyInput!) {
    companyHandler(input: $input) {
      id
      name
      address
      landing_percent
      labor_cost
      principal_person
      date_created
      phone_number
      fax_number
      main_contact
      main_contact_email
      billing_email
      sales_contact
      sales_email
      service_center
      distributor_type
      billing_contact
      status
      discount
    }
  }
`;
export const adminUtilHandler = /* GraphQL */ `
  mutation AdminUtilHandler($input: AdminUtilInput!) {
    adminUtilHandler(input: $input) {
      id
      important_update
      marketing_material
      tech_news
    }
  }
`;
export const personCompanyRoleHandler = /* GraphQL */ `
  mutation PersonCompanyRoleHandler($input: PersonCompanyRoleInput!) {
    personCompanyRoleHandler(input: $input) {
      user_id
      company_id
      role_id
      role_name
      name
      address
      landing_percent
      labor_cost
      principal_person
      date_created
      phone_number
      fax_number
      main_contact
      main_contact_email
      billing_email
      sales_contact
      sales_email
      service_center
      distributor_type
      billing_contact
      status
      discount
    }
  }
`;
export const companyFromPersonCompanyRoleHandler = /* GraphQL */ `
  mutation CompanyFromPersonCompanyRoleHandler(
    $input: PersonCompanyRoleInput!
  ) {
    companyFromPersonCompanyRoleHandler(input: $input) {
      user_id
      company_id
      role_id
      role_name
      name
      address
      landing_percent
      labor_cost
      principal_person
      date_created
      phone_number
      fax_number
      main_contact
      main_contact_email
      billing_email
      sales_contact
      sales_email
      service_center
      distributor_type
      billing_contact
      status
      discount
    }
  }
`;
export const warrantyHandler = /* GraphQL */ `
  mutation WarrantyHandler($input: WarrantyInput) {
    warrantyHandler(input: $input) {
      id
      serial_id
      reference_number
      company_id
      oil_cost
      freight
      comment
      date_of_purchase
      contact_number
      approved
      total
      submitted
      instance_landing
      instance_labor
    }
  }
`;
export const warrantyServicePartHandler = /* GraphQL */ `
  mutation WarrantyServicePartHandler($input: WarrantyServicePartInput) {
    warrantyServicePartHandler(input: $input) {
      warranty_id
      service_code
      part_number
      price
      qty
    }
  }
`;
export const jobHandler = /* GraphQL */ `
  mutation JobHandler($input: JobInput) {
    jobHandler(input: $input) {
      id
      name
    }
  }
`;
export const jobRoleHandler = /* GraphQL */ `
  mutation JobRoleHandler($input: JobRoleInput) {
    jobRoleHandler(input: $input) {
      job_id
      role_id
    }
  }
`;
export const companyJobHandler = /* GraphQL */ `
  mutation CompanyJobHandler($input: CompanyJobInput) {
    companyJobHandler(input: $input) {
      company_id
      job_id
    }
  }
`;
export const addToAdmin = /* GraphQL */ `
  mutation AddToAdmin($input: AddToAdminInput) {
    addToAdmin(input: $input) {
      Username
      UserStatus
      Attributes {
        Name
        Value
      }
    }
  }
`;
export const removeFromAdmin = /* GraphQL */ `
  mutation RemoveFromAdmin($input: AddToAdminInput) {
    removeFromAdmin(input: $input) {
      users {
        Username
        UserStatus
        Attributes {
          Name
          Value
        }
      }
    }
  }
`;
export const transfer = /* GraphQL */ `
  mutation Transfer($input: TransferInput) {
    transfer(input: $input) {
      errors {
        order_number
        product_code
        po_number
        serial
        production_date
      }
    }
  }
`;
export const batchHandler = /* GraphQL */ `
  mutation BatchHandler($input: BatchInput) {
    batchHandler(input: $input) {
      order_number
      product_code
      po_number
      serial
      production_date
    }
  }
`;
export const cancellationSes = /* GraphQL */ `
  mutation CancellationSes($input: SESInput) {
    cancellationSES(input: $input) {
      res
    }
  }
`;
export const itemMultiReader = /* GraphQL */ `
  mutation ItemMultiReader($input: ItemInput!) {
    itemMultiReader(input: $input) {
      serial
      product_id
      person_id
      date_purchase
      date_production
      image_key
      order_number
      po_number
    }
  }
`;
